import { useState } from 'react';

const features = [
  {
    id: 1,
    title: '恋愛の悩み・体の変化',
    description: '誰にも言えない恋の悩み、体つきが変わってくることへの不安。経験者だからこそ、あなたの気持ちに寄り添えます。',
    image: 'https://public.readdy.ai/ai/img_res/15dbcf0fe374934bdd4c4a62d53fc301.jpg'
  },
  {
    id: 2,
    title: '食事や体型についての気持ちのモヤモヤ',
    description: '食事や体型についての気持ちのモヤモヤや不安。私自身が経験者だから、その複雑な気持ちを理解できます。一緒に向き合いましょう。※治療・指導・改善方法の提案は行いません',
    image: 'https://readdy.ai/api/search-image?query=gentle%20morning%20light%20through%20window%20soft%20shadows%20peaceful%20calm%20atmosphere%20abstract%20minimalist%20composition%20warm%20beige%20tones%20hope%20and%20healing%20theme%20suitable%20for%20mental%20health%20counseling%20high%20quality&width=400&height=700&seq=feature-02&orientation=portrait'
  },
  {
    id: 3,
    title: '同じ考えが頭から離れないことによる困り感',
    description: '同じ考えが頭から離れない、安心するための行動が止められない。親に理解されない気持ち、毎日の小さな不安。どんな悩みも大切に。自分の思考の癖を一緒に見つめます。',
    image: 'https://readdy.ai/api/search-image?query=soft%20natural%20landscape%20with%20gentle%20green%20plants%20peaceful%20nature%20scene%20calming%20atmosphere%20warm%20sunlight%20abstract%20artistic%20style%20hope%20growth%20theme%20suitable%20for%20wellness%20counseling%20minimalist%20composition%20high%20contrast&width=400&height=700&seq=feature-03&orientation=portrait'
  },
  {
    id: 4,
    title: '親との関係のモヤモヤ',
    description: '親のことは好きなのに、なぜかイライラしてしまう。わかってほしいのに伝わらない。そんな複雑な気持ち、一緒に整理しましょう。',
    image: 'https://readdy.ai/api/search-image?query=warm%20soft%20afternoon%20light%20filtering%20through%20leaves%20gentle%20peaceful%20atmosphere%20abstract%20artistic%20composition%20pastel%20tones%20family%20connection%20theme%20suitable%20for%20teen%20counseling%20minimalist%20style%20high%20contrast%20emotional%20depth&width=400&height=700&seq=feature-04&orientation=portrait'
  }
];

export default function Features() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section id="services" className="py-24 bg-[#FFF8F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 inline-flex items-center gap-3">
            こんな時、話してみませんか? <span className="text-3xl">🌱</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className={`relative rounded-3xl overflow-hidden transition-all duration-500 cursor-pointer ${
                hoveredId === feature.id ? 'scale-105 shadow-2xl' : 'shadow-lg'
              }`}
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setHoveredId(feature.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              {/* Background Image */}
              <div className="absolute inset-0 w-full h-full">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="absolute inset-0 p-8 flex flex-col justify-end">
                <h3 className="text-2xl font-bold text-white mb-3">
                  {feature.title}
                </h3>
                <p className={`text-white/90 text-sm leading-relaxed transition-all duration-300 ${
                  hoveredId === feature.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow border-2 border-gray-100">
            <div className="w-16 h-16 bg-[#FFD93D]/20 rounded-full flex items-center justify-center mb-6">
              <i className="ri-video-line text-[#FFD93D] text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Google Meet</h3>
            <p className="text-gray-600 leading-relaxed">
              安全で使いやすいGoogle Meetでのオンラインセッション。お好きな場所から気軽に参加できます。
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow border-2 border-gray-100">
            <div className="w-16 h-16 bg-[#FF9B8A]/20 rounded-full flex items-center justify-center mb-6">
              <i className="ri-wallet-line text-[#FF9B8A] text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">3,000円</h3>
            <p className="text-gray-600 leading-relaxed">
              学生でも利用しやすい料金設定。40分間のセッションで、しっかりとお話を伺います。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
